import {
  createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vant from 'vant'

const app = createApp(App)
import '../public/js/flexible'

import 'vant/lib/index.css'
import '../public/css/base.css'

// 添加路由拦截
router.beforeEach((to, form, next) => {
  if (to.meta.isLogin) {
    let token = localStorage.getItem('token')
    if (token) {
      next()
    } else {
      if(to.path == '/') {
        router.push('/store')
        return
      }
      next({
        path: '/user/login'
      })
    }
  } else {
    next()
  }
})

import Header from '@/components/Header.vue'
import Loading from '@/components/loading.vue'
import Scroll from '@/components/Scroll.vue'
import noData from '@/components/noData.vue'
app.component('Header', Header)
app.component('Loading', Loading)
app.component('Scroll', Scroll)
app.component('noData', noData)

app.use(store).use(router).use(vant).mount('#app')